import React, {useState, useRef} from 'react';
import AddressModal from "../../AddressModal/AddressModal";
import InfoModal from "../../InfoModal/InfoModal";
import {Link} from "react-router-dom";
import {Accordion} from "react-bootstrap";

const App3 = () => {

    const [showAddressModal, setShowAddressModal] = useState(false);

    const handleShowAddressModal = () => setShowAddressModal(true);
    const handleCloseAddressModal = () => setShowAddressModal(false);
    const modalRef = useRef();
    const modalRef2 = useRef();
    const modalRef3 = useRef();
    const photoVideoGuideTitle = "Участнику вступительных испытаний, проводимых ГГУ";

    const photoVideoGuide = (
        <div>
            <div>
                <h3>
                    Памятка, для поступающих на творческие направления:
                </h3>
                <h4>На творческий экзамен по рисунку необходимо иметь при себе:</h4>
                <ul>
                    <li>Лист формата А2</li>
                    <li>Карандаши простые</li>
                    <li>Ластик</li>
                    <li>Кнопки канцелярские или молярный скотч</li>
                    <li><i>Хорошее настроение</i></li>
                </ul>
                <h4>На творческий экзамен по живописи необходимо иметь при себе:</h4>
                <ul>
                    <li>Лист формата А2</li>
                    <li>Краски на выбор (акварель, гуашь, темпера), кисти</li>
                    <li>
                        Кнопки канцелярские или молярный скотч, баночка для воды, тряпочка
                    </li>
                    <li><i>Хорошее настроение</i></li>
                </ul>
            </div>
        </div>
    );

    const testingFeaturesTitle = "Особенности проведения тестирования";

    const testingFeatures = (
        <div>
            <h3>Особенности проведения тестирования:</h3>
            <ul style={{listStyle: 'decimal'}}>
                <li>На выполнение теста абитуриентам отводится 60 минут.</li>
                <li>Тестирование включает 20 заданий, каждое из которых содержит вопрос, требующий выбора
                    правильного ответа.
                </li>
                <li>Каждое правильно выполненное задание оценивается 5 баллами.</li>
            </ul>
            <h3>Во время экзамена запрещается:</h3>
            <ul>
                <li>громко разговаривать</li>
                <li>выходить из помещения без разрешения наблюдателя</li>
                <li>использовать любые технические средства в качестве шпаргалок</li>
                <li>производить фотосъемку работ</li>
                <li>использовать любые мобильные и цифровые устройства во время испытаний</li>
                <li>задерживать сдачу работы по истечении времени, отведённого на выполнение работы</li>
            </ul>
        </div>
    );

    const specialNeedsExamTitle = "Вступительные испытания для поступающих с ОВЗ и инвалидностью";

    const specialNeedsExam = (
        <div>
            <h3>Условия проведения вступительных испытаний для поступающих с ограниченными возможностями здоровья</h3>
            <p>
                Университет обеспечивает проведение вступительных испытаний для поступающих с ограниченными возможностями здоровья и (или) инвалидов с учетом их индивидуальных особенностей.
            </p>
            <p>
                Обеспечены условия беспрепятственного доступа в аудитории, туалеты и другие помещения.
            </p>
            <p>
                Вступительные испытания проводятся в отдельных аудиториях:
            </p>
            <ul>
                <li>письменная форма — не более 12 человек в аудитории;</li>
                <li>устная форма — не более 6 человек в аудитории.</li>
            </ul>
            <p>
                Допускается проведение в одной аудитории с другими поступающими, если это не мешает сдаче экзамена.
            </p>
            <p>
                В аудитории может присутствовать ассистент для технической помощи.
            </p>
            <p>
                Все условия предоставляются по заявлению с указанием необходимости специальных условий.
            </p>
            <p>
                Время экзамена может быть увеличено максимум на 1,5 часа.
            </p>
            <p>
                Поступающим предоставляется информация в доступной форме. Разрешено использовать технические средства.
            </p>

            <h4>Дополнительные условия в зависимости от особенностей:</h4>
            <ul>
                <li>
                    <strong>Слепые:</strong> задания — шрифт Брайля, электронные форматы или зачитывание ассистентом; выполнение — Брайль, компьютер или надиктовка.
                </li>
                <li>
                    <strong>Слабовидящие:</strong> освещение не менее 300 люкс, увеличивающие устройства, увеличенный шрифт.
                </li>
                <li>
                    <strong>Глухие и слабослышащие:</strong> звукоусиливающая аппаратура, услуги сурдопереводчика.
                </li>
                <li>
                    <strong>Слепоглухие:</strong> услуги тифлосурдопереводчика, а также требования для слепых и глухих.
                </li>
                <li>
                    <strong>Нарушения речи:</strong> устные испытания проводятся письменно.
                </li>
                <li>
                    <strong>Нарушения опорно-двигательного аппарата:</strong> задания выполняются на компьютере или надиктовываются; письменные испытания могут быть заменены устными.
                </li>
            </ul>
            <p>
                Вступительные испытания могут проходить с использованием дистанционных технологий.
            </p>
        </div>
    );

    return (
        <div className="DocumentLinksPage__content-container">
            <h2>Вступительные испытания</h2>
            <p>Все вступительные испытания проводятся на <b>русском языке</b>.
                Проведение вступительного испытания на иностранном языке и на языке субъектов
                Российской Федерации при поступлении в ГГУ не предусмотрено.</p>
            <p>
                <h6>Университет проводит вступительные испытания:</h6>
                <ul>
                    <li>в рамках контрольных цифр приема очно</li>
                    <li>по договорам об оказании платных образовательных услуг очно или
                        с использованием дистанционных технологий.
                    </li>
                </ul>
                <h5 style={{textAlign: "center"}}>Минимальные баллы по вступительным испытаниям творческой и
                    профессиональной направленности</h5>
                <table>
                    <thead>
                    <tr>
                        <th>Код</th>
                        <th>Специальность</th>
                        <th>Вступительные испытания<br/>(в порядке приоритета)</th>
                        <th>Минимальное количество баллов<br/>бюджет</th>
                        <th>Минимальное количество баллов<br/>внебюджет</th>
                        <th>Форма проведения<br/>вступительных испытаний</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>54.02.02</td>
                        <td>Декоративно-прикладное искусство и народные промыслы (по видам)</td>
                        <td>Рисунок<br/>Живопись</td>
                        <td>50<br/>50</td>
                        <td>40<br/>40</td>
                        <td rowSpan="3">Творческий конкурс</td>
                    </tr>
                    <tr>
                        <td>54.02.01</td>
                        <td>Дизайн (по отраслям)</td>
                        <td>Рисунок<br/>Живопись</td>
                        <td>60<br/>60</td>
                        <td>50<br/>50</td>
                    </tr>
                    <tr>
                        <td>54.02.05</td>
                        <td>Живопись (по видам)</td>
                        <td>Рисунок<br/>Живопись</td>
                        <td>50<br/>50</td>
                        <td>40<br/>40</td>
                    </tr>
                    <tr>
                        <td>54.02.07</td>
                        <td>Скульптура</td>
                        <td>Рисунок</td>
                        <td>40</td>
                        <td>30</td>
                        <td>Творческий конкурс</td>
                    </tr>
                    <tr>
                        <td>51.02.01</td>
                        <td>Народное художественное творчество (по видам)</td>
                        <td>Специальность</td>
                        <td>60</td>
                        <td>50</td>
                        <td>Творческий конкурс, собеседование</td>
                    </tr>
                    <tr>
                        <td>51.02.02</td>
                        <td>Социально-культурная деятельность (по видам)</td>
                        <td>Специальность</td>
                        <td>60</td>
                        <td>50</td>
                        <td>Творческий конкурс, собеседование</td>
                    </tr>
                    <tr>
                        <td>49.02.01</td>
                        <td>Физическая культура</td>
                        <td>Физическая культура</td>
                        <td>50</td>
                        <td>40</td>
                        <td>Экзамен по физической культуре</td>
                    </tr>
                    </tbody>
                </table>
            </p>

            <p>
                <ul>
                    <li>Вступительные испытания проводятся с 11 августа по 15 августа {new Date().getFullYear()} г.</li>
                </ul>
            </p>

            <p>
                <b>Место проведения вступительных испытаний:</b> Московская область, Раменский городской округ, пос.
                Электроизолятор, д. 67
                (<Link to="#" onClick={(e) => {
                e.preventDefault();
                handleShowAddressModal();
            }}>
                как добраться
            </Link>)
            </p>
            <AddressModal show={showAddressModal} onHide={handleCloseAddressModal} showRepresentation={false}/>
            <p>
                На экзамене при себе необходимо иметь паспорт для идентификации Вашей личности, а
                также шариковую ручку.
                На дополнительных вступительных испытаниях творческой и профессиональной направленности Вам необходимо
                принести{" "}
                <Link to="#" onClick={(e) => {
                    e.preventDefault();
                    modalRef.current.openModal();
                }}>
                    следующие принадлежности
                </Link>.
            </p>
            <InfoModal
                ref={modalRef}
                title={photoVideoGuideTitle}
                description={photoVideoGuide}
            />

            <InfoModal
                ref={modalRef2}
                title={testingFeaturesTitle}
                description={testingFeatures}
            />

            <InfoModal
                ref={modalRef3}
                title={specialNeedsExamTitle}
                description={specialNeedsExam}
            />

            <p>
                <a
                    href="/pdf/entrance_examinations_SPO_2025.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Расписание вступительных испытаний
                </a> <br/>
                <Link to="#" onClick={(e) => {
                    e.preventDefault();
                    modalRef3.current.openModal();
                }}>
                    Вступительные испытания для поступающих с ОВЗ и инвалидностью
                </Link>
            </p>
            <p>
                <h5>Программы вступительных испытаний, проводимых организацией самостоятельно:</h5>
                <Accordion>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>Программы вступительных испытаний</Accordion.Header>
                        <Accordion.Body>
                            <ul>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/spo/doc/RIS_SPO_2025.pdf" target="_blank"
                                       rel="noopener noreferrer">
                                        Программа вступительных испытаний по рисунку
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/spo/doc/NHT_SPO_2025.pdf" target="_blank"
                                       rel="noopener noreferrer">
                                        Программа вступительного испытания для абитуриентов, поступающих на
                                        специальность Народное художественное творчество
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/spo/doc/FK_SPO_2025.pdf" target="_blank"
                                       rel="noopener noreferrer">
                                        Программа вступительного испытания для абитуриентов, поступающих на
                                        специальность Физическая культура
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/spo/doc/JIV_SPO_2025.pdf" target="_blank"
                                       rel="noopener noreferrer">
                                        Программа вступительных испытаний по живописи
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/spo/doc/SKD_SPO_2025.pdf" target="_blank"
                                       rel="noopener noreferrer">
                                        Программа вступительных испытаний для абитуриентов, поступающих на специальность
                                        Социально-культурная деятельность
                                    </a>
                                </li>
                            </ul>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </p>
        </div>
    );
}

export default App3;